import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BasePasswordForm } from '@/components/core';
import { useAccountActivation } from '../../hooks/use-auth';
import { setPasswordFormDefaultValue, getSetPasswordFormValidationSchema } from './utils';

/**
 * SetPasswordForm — account activation. Organization is chosen after login
 * on /select-organization (not during activate).
 */

export const SetpasswordForm = ({ code }: Readonly<{ code: string }>) => {
  const { t } = useTranslation();
  const { isPending, mutateAsync } = useAccountActivation();
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);

  const captchaEnabled = (import.meta.env.VITE_CAPTCHA_SITE_KEY || '') !== '';

  const handleSubmit = async (
    password: string,
    code: string,
    captchaToken?: string,
    formData?: { firstName?: string; lastName?: string }
  ) => {
    if (captchaEnabled && !captchaToken) {
      return;
    }

    await mutateAsync({
      firstname: formData?.firstName ?? '',
      lastname: formData?.lastName ?? '',
      password,
      code,
      captchaCode: captchaToken ?? '',
      projectKey: import.meta.env.VITE_X_BLOCKS_KEY || '',
    });
  };

  const handleCaptchaValidation = (isValid: boolean) => {
    setIsCaptchaValid(isValid);
  };

  return (
    <BasePasswordForm
      code={code}
      onSubmit={handleSubmit}
      validationSchema={getSetPasswordFormValidationSchema(t)}
      defaultValues={setPasswordFormDefaultValue}
      isPending={isPending}
      isCaptchaValid={isCaptchaValid}
      onCaptchaValidation={handleCaptchaValidation}
      showNameFields={true}
      theme="login"
    />
  );
};
